<template>
    <MainView />
</template>

<script>
/* eslint-disable no-underscore-dangle */

function getCmpName() {
    const containers = {
        booking: 'BookingContainer',
        bookingLayer: 'BookingLayerContainer',
        assignment: 'AssignmentContainer',
        mapviewer: 'MapViewerContainer',
    };

    if (
        window.__APP_CONFIG__ &&
        window.__APP_CONFIG__.container &&
        containers[window.__APP_CONFIG__.container]
    ) {
        return containers[window.__APP_CONFIG__.container];
    }

    return 'BookingContainer';
}

const cmpName = getCmpName();
const MainView = () => import(`@/components/containers/${cmpName}`);

export default {
    components: {
        MainView,
    },
    name: 'app',
    data() {
        return {};
    },
};
</script>



// WEBPACK FOOTER //
// src/App.vue